import { Pipe, PipeTransform } from '@angular/core';
import { IAssetGateway } from '@app/lib/asset-gateway.interface';
import { isModelAG31, isModelAG55 } from '@app/lib/asset-gateway.utils';
import { ASSET_GATEWAY, ASSET_GATEWAY_MINI } from '@app/lib/asset-gateway.consts';

@Pipe({ name: 'agModelName' })
export class AGModelNamePipe implements PipeTransform {
  public transform(assetGateway: IAssetGateway): string {
    if (isModelAG31(assetGateway)) return ASSET_GATEWAY_MINI;
    else if (isModelAG55(assetGateway)) return ASSET_GATEWAY;
    return '';
  }
}
